import Markdown from "../Markdown"
import styles from "./ConteudoTexto.module.css"

export const ConteudoTexto = ({ value, blacklisted }: { value: string, blacklisted?: boolean }) => {
    return (<>
        <Markdown linksNovaAba className={[blacklisted ? styles.blacklisted : '', "rr-mask"].join(' ')} value={value} />
        {blacklisted && (
            <div style={{ color: 'var(--tc-color-gray-500)', fontStyle: 'italic', marginTop: '4px', fontSize: '0.75rem' }}>
                Trechos da mensagem contém palavras bloqueadas. Bot não irá responder a esta mensagem.
            </div>
        )}
    </>
    )
}